import { CTAColorVariant } from '~/components/shared/CTAButton';

export const DEFAULT_PROPS = {
  headline: 'Members get more with Video Streaming Choice',
  disclaimer: `Choose one ad-supported service every 90 days: Peacock Premium or Paramount+ Essential. Add’l registration req’d. T&C apply.`,
  CTAButtonText: 'Claim your free trial',
  CTAButtonVariant: 'primary-blue' as CTAColorVariant,
  CTAButtonLink: 'https://www.walmart.com/plus/plans',
  showImageMobile: true,
  imageDesktop: 'rebrand-walmart-logo-blue.svg',
  imageAltText: 'Walmart+ logo',
  hasSecondaryCTAButton: false,
  secondaryCTAButtonText: 'Or skip offer & claim trial',
  secondaryCTAButtonLink: 'https://www.walmart.com/plus/plans',
  secondaryCTAButtonVariant: 'text-link' as CTAColorVariant,
};
